import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getForm } from 'common/entities/form/selectors';

import { getFormId } from '../../selectors';
import { openEditFormHeadlineView } from '../../actions';
import { FormEditorRow } from './FormEditorRow';

const LABEL = 'Headline';
const SUBTITLE_FALLBACK = '(Not set)';

class HeadlineNode extends React.Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        formId: PropTypes.string.isRequired,
        openEditFormHeadlineView: PropTypes.func.isRequired,
    };

    handleClick = (event) => {
        event.stopPropagation();
        this.props.openEditFormHeadlineView(this.props.formId);
    };

    render() {
        const { label } = this.props;
        return (
            <FormEditorRow subtitle={label || SUBTITLE_FALLBACK} onClick={this.handleClick}>
                {LABEL}
            </FormEditorRow>
        );
    }
}

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const form = getForm(state, formId);

    return {
        formId: form ? form.id : null,
        label: form ? form.label : null,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            openEditFormHeadlineView,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(HeadlineNode);
